






import Vue from 'vue';
import { mapActions } from 'vuex';

export default Vue.extend({
    name: 'employees',
    methods: {
        ...mapActions('employees', ['getEmployees']),
    },
    created() {
        this.getEmployees();
    },
});
